import { render, staticRenderFns } from "./econDialog.vue?vue&type=template&id=5b41ddde&scoped=true"
import script from "./econDialog.vue?vue&type=script&lang=js"
export * from "./econDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b41ddde",
  null
  
)

export default component.exports